// extracted by mini-css-extract-plugin
export default {"post":"Posts_post__75lmk","postsH2":"Posts_postsH2__pYopM","link":"Posts_link__Tsw9c"};